import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { makeSelectStoredSearch } from './selectors';

export function useStoredSearch(pathname: string): string {
  const selectStoredSearch = useMemo(
    () => makeSelectStoredSearch(pathname),
    [pathname]
  );

  const storedSearch = useSelector(selectStoredSearch, shallowEqual);

  return storedSearch;
}
